// extracted by mini-css-extract-plugin
export default {"weekday":"UpcomingDaysForecastItem_weekday__n2dKt"};